import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
  path: '/',
  name: 'index',
  component: () => import('../views/screen.vue'),
  meta: {title:"大屏1"}
},{
  path: '/screen2',
  name: 'screen2',
  component: () => import('../views/screen2.vue'),
  meta: {title:"大屏2"}
},{
  path: '/screen3',
  name: 'screen3',
  component: () => import('../views/screen3.vue'),
  meta: {title:"大屏3"}
},{
  path: '/zhcf_screen',
  name: 'screen',
  component: () => import('../views/index.vue')
}]
const router = new VueRouter({
  mode: "history",
  routes
})

export default router
